import * as React from 'react';
import { copyIcon } from '../../Shared/index';
import DemoGuardedButton from '../components/shared/demoGuardedButton';

const copyImage = <img alt={copyIcon.alt} src={copyIcon.src} />

export const DUE_DATE_DEFAULT_TEXT = 'No due date'
export const PUBLISH_DATE_DEFAULT_TEXT = 'Right away'
export const INVALID_DATES_SNACKBAR_COPY = 'The due date must be after the publish date.'

export const formatDateTimeForDisplay = (datetime) => {
  if (datetime.minutes()) {
    return datetime.format('MMM D, h:mma')
  }
  return datetime.format('MMM D, ha')
}

export const CopyToAllButton = ({ disabled, isDemoProtected, handleClickCopyToAll }: { disabled?: boolean, isDemoProtected?: boolean, handleClickCopyToAll: (e) => void } ) => {
  if(isDemoProtected) {
    return (
      <DemoGuardedButton
        className={`quill-button extra-small grey outlined icon focus-on-light copy-to-all-button ${disabled ? 'disabled' : ''}`}
        disabled={disabled}
        onClick={handleClickCopyToAll}
      >
        {copyImage}
        <span>Copy to all</span>
      </DemoGuardedButton>
    )
  }
  return (
    <button
      className={`quill-button extra-small grey outlined icon focus-on-light copy-to-all-button ${disabled ? 'disabled' : ''}`}
      disabled={disabled}
      onClick={handleClickCopyToAll}
      type="button"
    >
      {copyImage}
      <span>Copy to all</span>
    </button>
  )
}
